import { render, staticRenderFns } from "./TourCancellation.vue?vue&type=template&id=5c5bf0eb"
import script from "./TourCancellation.vue?vue&type=script&lang=js"
export * from "./TourCancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5bf0eb')) {
      api.createRecord('5c5bf0eb', component.options)
    } else {
      api.reload('5c5bf0eb', component.options)
    }
    module.hot.accept("./TourCancellation.vue?vue&type=template&id=5c5bf0eb", function () {
      api.rerender('5c5bf0eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourCancellation.vue"
export default component.exports